import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  author?: string;
  cover: string;
  category?: string;
  rating?: number;
  views?: string;
  chapters?: number;
  status?: string;
  tags?: string[];
  newChapter?: string;
  updateTime?: string;
  rank?: number;
  variant?: 'default' | 'ranking' | 'compact';
}

export default function ComicCard({
  id, title, author, cover, category, rating, views, chapters, status, tags, newChapter, updateTime, rank, variant = 'default',
}: ComicCardProps) {
  if (variant === 'compact') {
    return (
      <Link to={`/comic/${id}`} className="flex items-center gap-3 p-2 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group">
        <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0">
          <img src={cover} alt={title} className="w-full h-full object-cover object-top" loading="lazy" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">{title}</h4>
          {newChapter && <p className="text-xs text-foreground-500 mt-0.5">{newChapter}</p>}
          {updateTime && <p className="text-xs text-foreground-400 mt-0.5">{updateTime}</p>}
        </div>
      </Link>
    );
  }

  return (
    <Link to={`/comic/${id}`} className="block cursor-pointer group" data-product-shop="">
      <div className="relative rounded-lg overflow-hidden bg-background-100">
        <div className="aspect-[3/4] overflow-hidden">
          <img src={cover} alt={title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" loading="lazy" />
        </div>
        {rank && variant === 'ranking' && (
          <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center bg-accent-500 text-background-50 text-xs font-bold rounded-md">
            {rank}
          </div>
        )}
        {status && (
          <div className={`absolute top-2 right-2 px-2 py-0.5 rounded text-xs font-medium ${
            status === '连载中' ? 'bg-primary-500 text-background-50' : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </div>
        )}
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">{title}</h3>
        <div className="flex items-center gap-2 mt-1">
          {category && <span className="text-xs text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded">{category}</span>}
          {rating && (
            <span className="flex items-center gap-0.5 text-xs text-foreground-500">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {rating}
            </span>
          )}
        </div>
        {newChapter && (
          <p className="text-xs text-primary-600 mt-1 truncate">{newChapter}</p>
        )}
        {updateTime && (
          <p className="text-xs text-foreground-400 mt-0.5">{updateTime}</p>
        )}
      </div>
    </Link>
  );
}